import { ViewUserResource, usePostAuthForgotPasswordMutation } from '@/api/serverApi'
import { Button, Modal, WarningIcon } from '@cfs-fixings/shared'
import toastHelper from '@cfs-fixings/shared/src/helpers/toastHelper'

const textSpec = {
  'title': 'Reset Password',
  'content': 'Are you sure you want to reset this user\'s password? They will be emailed a link to reset their password.',
  'confirmButtonLabel': 'Reset Password',
  'cancelButtonLabel': 'Cancel',
  'successToast': {
    'title': 'Password reset successfully',
    'content': 'Password Reset',
  },
  'errorToast': {
    'title': 'Failed to reset password',
    'content': 'An error occurred while resetting the password',
  },
}

type PropTypes = {
  isOpen: boolean,
  onClose: () => void,
  user?: ViewUserResource,
}

const ResetUserPasswordModal = ({ isOpen, onClose, user }: PropTypes) => {
  const [resetPassword, { isLoading }] = usePostAuthForgotPasswordMutation()

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={<div className="flex items-center gap-2">
        <WarningIcon className="bg-red-500 h-[40px] w-[40px] p-[9px] rounded-md drop-shadow-md"  />
        {textSpec.title}
      </div>}
      size="md"
      content={
        <div className="flex flex-col gap-6">
          <div className="text-start text-sm mr-7 text-gray-650">{textSpec.content}</div>
          {
            user
              && <div className="flex gap-3 justify-end w-full">
                <Button
                  variant="outline"
                  onClick={onClose}
                  isDisabled={isLoading}
                >
                  {textSpec.cancelButtonLabel}
                </Button>
                <Button
                  onClick={() => {
                    resetPassword({
                      body: {
                        email: user!.email,
                      },
                    }).unwrap().then(() => {
                      onClose()
                      toastHelper.success(textSpec.successToast.title, textSpec.successToast.content)
                    }).catch(() => {
                      onClose()
                      toastHelper.error(textSpec.errorToast.title, textSpec.errorToast.content)
                    })
                  }}
                  isLoading={isLoading}
                  variant={'danger'}
                >
                  {textSpec.confirmButtonLabel}
                </Button>
              </div>
          }
        </div>
      }
    />
  )
}

export default ResetUserPasswordModal
